import { useEffect } from "react";
import { useCurrentUser } from "../../hooks/useGetUserDetail";
import { PROFILE_TYPE } from "../../utils/constants";
import Admin from "./Admin/Admin";
import "./dashboard.scss";
import SuperAdmin from "./SuperAdmin/SuperAdmin";

const Dashboard = () => {
  const { data: userInfo } = useCurrentUser();
  const isSuperAdmin =
    userInfo?.profileType.toLowerCase() === PROFILE_TYPE.SUPER_ADMIN;

  // Block browser back / forward buttons while on the Rooms screen.
  // pushState adds a sentinel entry so the first Back press lands here;
  // the popstate handler immediately re-pushes to neutralise every subsequent press.
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    <>
      {isSuperAdmin && <SuperAdmin />}
      {!isSuperAdmin && <Admin />}
    </>
  );
};

export default Dashboard;
